<template>
  <div class="homeServicos w-full">
    <div class="auto-container flex flex-wrap w-full gap-3">
      <div class="flex w-full lg:w-6">
        <div class="homepage-title-group">
          <span class="sectionTitle white" v-html="titulo"></span>
          <div class="subtitulo" v-html="subtitulo"></div>
        </div>
      </div>
      <div class="btn flex w-full lg:w-5">
        <div @click="fc_goRoute('servicos')" class="btn-redireciona flex" v-html="fc_getText(null, 'btn_saibaMais')"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    titulo: String,
    subtitulo: String
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.homeServicos {
  background: url("@/assets/banners/magazine_parallax.jpg") no-repeat center center;
  background-attachment: fixed;
  background-size: cover;
}
.homeServicos .homepage-title-group {
  margin-top: 100px;
  margin-bottom: 100px;
}
.homeServicos .btn {
  display: flex;
  align-items: center;
  justify-content: center;
}
.homeServicos .subtitulo {
  margin: 10px 0px 20px 0px;
  line-height:1.2em;
  color: #fff;
  font-size:24px;
}
.homeServicos .description p {
  padding-bottom: 20px;
  color: #fff;
}
@media screen and (max-width:1040px) {
  .homeServicos .homepage-title-group {
    margin-top: 80px;
    margin-bottom: 40px;
  }
}
@media screen and (max-width:992px) {
  .homeServicos .btn-redireciona {
    margin-bottom: 40px;
  }
}
</style>
